import React, { useEffect, useState } from "react";
import newsLetterImage from "assets/images/newsletter.svg";
import closeImage from "assets/images/close.svg";
import Button from "components/ReusableComponents/Button/Button";

function ThankyouPopup({
  setShowThankyou,
  title,
  description,
  style,
  customStyle,
}) {
  return (
    <div
      className={`ease-in-out duration-300 bg-[#F4E3C4] rounded-md ${style} sm:py-[131px] py-[50px] z-[999999] ${
        customStyle
          ? customStyle
          : "bg-goldLight md:w-[706px] md:max-w-[706px] sm:w-[650px] max-w-[650px] "
      } flex flex-col sm:flex-row items-center sm:justify-center  gap-8`}
    >
      <img
        src={closeImage}
        alt="close-popup"
        className="absolute top-2 right-2 cursor-pointer"
        onClick={() => setShowThankyou(false)}
      />

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="84"
        height="84"
        viewBox="0 0 84 84"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 42C0 30.8609 4.42499 20.178 12.3015 12.3015C20.178 4.42499 30.8609 0 42 0C53.1391 0 63.822 4.42499 71.6985 12.3015C79.575 20.178 84 30.8609 84 42C84 53.1391 79.575 63.822 71.6985 71.6985C63.822 79.575 53.1391 84 42 84C30.8609 84 20.178 79.575 12.3015 71.6985C4.42499 63.822 0 53.1391 0 42ZM39.6032 59.976L63.784 29.7472L59.416 26.2528L38.7968 52.0184L24.192 39.8496L20.608 44.1504L39.6032 59.9816V59.976Z"
          fill="#028E32"
        />
      </svg>
      <div className=" flex flex-col  justify-center">
        <h2 className="text-2xl sm:text-4xl text-black text-center sm:text-left xs:font-cairo pb-2">
          {title}
        </h2>
        <p className="mt-2 text-lg sm:text-xl text-black text-center sm:text-left xs:font-cairo">
          {description}
        </p>
        <form className="flex flex-col sm:flex-row gap-3 pt-5"></form>
      </div>
    </div>
  );
}
export default ThankyouPopup;
